import type { ReactNode } from 'react'
import { StorefrontBackdrop, StorefrontNav } from '../storefront/chrome'
import { Reveal } from '../../motion'

/**
 * AccountLayout — content shell for customer account pages.
 *
 * Navigation lives in the StorefrontNav hamburger -> CustomerSidebar
 * drawer (left slide-in with Orders History / Returns / Testimony).
 * This layout owns only the chrome (backdrop + nav) and renders the
 * page content full-width below it.
 *
 * Previously this layout also rendered a duplicate in-page left rail
 * with the same 3 links; removed 2026-06-17 per Kiran — the hamburger
 * drawer is the single source of customer navigation, matching the
 * operator dashboard pattern (DashboardShell + OperatorSidebar).
 */
export function AccountLayout({ children }: { readonly children: ReactNode }): JSX.Element {
  return (
    <div className="relative flex min-h-screen flex-col overflow-x-hidden">
      <div className="fixed inset-0 z-0">
        <StorefrontBackdrop />
      </div>
      <StorefrontNav fullWidth />
      <div className="relative z-10 flex-1 mx-auto max-w-7xl w-full px-4 sm:px-6 pt-24 pb-8">
        <Reveal as="section" amount={0.01}>{children}</Reveal>
      </div>
    </div>
  )
}
